import React from "react";
import reasonsToTreatFeetBanner from "./../../../../../Images/Blog/top_reasons_treat_feet/Banner.png";

const ReasonsToTreatFeetImg = () => {
  return (
    <div className="blogImg-content">
      <img
        src={reasonsToTreatFeetBanner}
        alt="reasons To Treat Feet Banner"
        loading="lazy"
      />
    </div>
  );
};

export default ReasonsToTreatFeetImg;
